import { InboundTab } from './InboundTab';
import { OutboundTab } from './OutboundTab';
import { ROUTE_QUERY_PARAM } from '../../app/Routes/const';
import { Tabs, Tab } from '../../components';
import { useTabPersistence } from '../../shared';

type TabsEnum = 'outbound' | 'inbound';
const SIP_TRUNK_TABS: TabsEnum[] = ['outbound', 'inbound'];

const SipTrunkPage = () => {
  const { selectedTab, setSelectedTab } = useTabPersistence(
    {
      paramName: ROUTE_QUERY_PARAM.TAB,
      defaultTab: SIP_TRUNK_TABS[0],
      updateHistory: true,
    },
    SIP_TRUNK_TABS
  );

  return (
    <>
      <Tabs<TabsEnum>
        tabs={[
          { name: 'outbound', label: 'Outbound' },
          { name: 'inbound', label: 'Inbound' },
        ]}
        activeTab={selectedTab}
        onChange={setSelectedTab}
        contentClassName="mt-md"
      >
        <Tab name="outbound">
          <OutboundTab />
        </Tab>
        <Tab name="inbound">
          <InboundTab />
        </Tab>
      </Tabs>
    </>
  );
};

export default SipTrunkPage;
